<div class="row content">
  <div *ngIf="!solicitou">
    <app-loader-circles *ngIf="showLoader"></app-loader-circles>
    <button class="btn btn-full-orange" (click)="solicitarToken()">
      <span class="fa fa-envelope"></span>
      {{ butonText }}
    </button>
  </div>

  <div *ngIf="solicitou">
    <form class="forms">
      <div class="space">
        <div
          class="inputs col-sm-4"
          [class.has-error]="tokenStatus === 'FAIL'"
          [formGroup]="tokenForm"
        >
          <label class="font-size">Digite o Token do Cliente</label>
          <input
            class="form-control text-token"
            type="text"
            placeholder="0 0 0 0 0 0"
            minlength="6"
            maxlength="6"
            name="codigoConfirmacao"
            formControlName="codigoConfirmacao"
            appOnlyNumberRestrictive
            autocomplete="off"
          />
          <div class="msg-token text-danger" *ngIf="tokenStatus === 'FAIL'">
            <span class="fa fa-ban msg-token-icon"></span>
            Token inválido
          </div>

          <div class="msg-token text-secondary" *ngIf="tokenStatus === 'SENT'">
            <span class="icon token-enviado msg-token-icon"></span>
            Token enviado!
          </div>
          
          <div class="msg-token text-success" *ngIf="tokenStatus === 'SUCCESS'">
            <span class="fa fa-check-circle-o msg-token-icon"></span>
            Token validado com sucesso!
          </div>
        </div>

        <app-loader-circles *ngIf="showLoader"></app-loader-circles>

        <div class="col-sm-4" *ngIf="tokenStatus !== 'SUCCESS'">
          <a
            class="btn btn-border-orange margin-button"
            (click)="solicitarToken()"
            *ngIf="!enviado"
          >
            <span class="fa fa-envelope"></span>
            Reenviar Token
          </a>
          <a
            class="btn btn-border-orange margin-button"
            *ngIf="enviado"
            [ngClass]="{ disabled: enviado }"
          >
            <span class="fa fa-envelope"></span>
            Reenviar em {{ timeLeft }}s
          </a>

          <div class="msg-spacing">
            <a (click)="openTokenNotReceivedInfoModal()" class="text-primary text-underline text-center"
              >O cliente não recebeu o token?</a
            >
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
